import React, { useState, useEffect, useRef } from "react";
import { Doughnut } from 'react-chartjs-2';
import { Chart } from 'chart.js';
import 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import '../css/MetricsByDepartment.css';
import { getObjetivos } from "../utils/peticionesApi";

Chart.register(ChartDataLabels);

const MetricsByDepartment = ({ onSelectDepartment }) => {
    const [objetivos, setObjetivos] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        listarObjetivos();
    }, []);

    const listarObjetivos = async () => {
        try {
            setIsLoading(true);
            const response = await getObjetivos();
            setObjetivos(response.data.content || []);
        } catch (error) {
            console.error("Error al obtener objetivos:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const labels = objetivos.map(obj => obj.name || "Sin nombre");
    const numObjetivos = labels.length;
    const valuePerObjective = numObjetivos > 0 ? parseFloat((100 / numObjetivos).toFixed(2)) : 0;
    const dataValues = Array(numObjetivos).fill(valuePerObjective);

    const backgroundColors = [
        '#8F3B8C', '#D47CD1', '#00D2CA', '#EC5B5B', '#FFD700', '#6495ED', '#90EE90',
        '#FF8C00', '#20B2AA', '#FF69B4', '#B0C4DE', '#32CD32'
    ];

    const chartData = {
        labels: labels,
        datasets: [
            {
                data: dataValues,
                backgroundColor: backgroundColors.slice(0, numObjetivos),
                borderColor: ['#fff'],
                borderWidth: 2,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
            animateRotate: true,
            animateScale: true
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.label}: ${context.raw}%`,
                },
                backgroundColor: '#3F63AC',
                titleColor: '#fff',
                bodyColor: '#fff',
            },
            datalabels: {
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: 14,
                },
                formatter: (value) => `${value}%`,
            },
        },

        onClick: (evt, elements, chart) => {
            if (elements && elements.length > 0) {
                const index = elements[0].index;
                const label = chart.data.labels[index];
                if (onSelectDepartment && label) {
                    onSelectDepartment(label);
                }
            }
        }
    };

    const chartRef = useRef();

    const handleClick = (event) => {
        const chart = chartRef.current;
        if (!chart) return;

        const elements = chart.getElementsAtEventForMode(event.nativeEvent, 'nearest', { intersect: true }, false);
        if (elements.length > 0) {
            const index = elements[0].index;
            const label = chart.data.labels[index];
            if (onSelectDepartment) onSelectDepartment(label);
        }
    };

    return (
        <div className="metrics-department-container">
            <h3 className="metrics-title">Métricas por departamento</h3>
            <div className="metrics-chart-wrapper">
                {isLoading ? (
                    <p>Cargando...</p>
                ) : (
                    <>
                        <div className="metrics-chart">
                            <Doughnut ref={chartRef} data={chartData} options={options} onClick={handleClick} />
                        </div>
                        <ul className="metrics-legend">
                            {labels.map((label, index) => (
                                <li key={index} className="legend-item">
                                    <span
                                        className="legend-color"
                                        style={{ backgroundColor: chartData.datasets[0].backgroundColor[index] }}
                                    ></span>
                                    <span className="legend-label">{label}</span>
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </div>
        </div>
    );
};

export default MetricsByDepartment;